module.exports = __webpack_public_path__ + "img/train.5c54eec6.png";